import { render } from "./EditingEpisodes.vue?vue&type=template&id=01e1c4c3"
import script from "./EditingEpisodes.vue?vue&type=script&lang=js"
export * from "./EditingEpisodes.vue?vue&type=script&lang=js"
script.render = render

export default script